const constants = {
  chartType: {
    line: 'line',
    histogram: 'histogram',
    bar: 'bar',
    point: 'point'
  },
  axisOrientation: {
    top: 'top',
    bottom: 'bottom',
    left: 'left',
    right: 'right'
  },
  scaleType: {
    categorical: 'categorical',
    linear: 'linear',
    log: 'log'
  },
  axisFormat: {
    date: 'date',
    number: 'number',
    percentage: 'percentage'
  },
  legendObject: {
    circle: 'circle',
    line: 'line',
    square: 'square'
  },
  symbol: {
    line: '—',
    circle: '•',
    square: '■'
  },
  orientation: {
    vertical: 'vertical',
    horizontal: 'horizontal'
  }
}

export default constants
